export const PASSWORD_MINIMUM_LENGTH = 12
export const PASSWORD_MAXIMUM_LENGTH = 50

export const hasMinimumLength = (password: string): boolean => password?.length >= PASSWORD_MINIMUM_LENGTH

export const hasOneCapitalLetterMin = (password: string): boolean => /[A-Z]/.test(password)

export const hasOneLowerCaseLetterMin = (password: string): boolean => /[a-z]/.test(password)

export const hasOneNumberMin = (password: string): boolean => /[0-9]/.test(password)

export const hasOneSpecialCharacterMin = (password: string): boolean =>
  /[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]+/.test(password)

export const passwordAllRules = (password: string): boolean =>
  hasMinimumLength(password) &&
  hasOneCapitalLetterMin(password) &&
  hasOneLowerCaseLetterMin(password) &&
  hasOneNumberMin(password) &&
  hasOneSpecialCharacterMin(password)

// Directory silently strips every name character outside Latin-1 letters, "-", "'" and spaces (its `normalize_names`
// normalizer), so a name like "123456" is stored empty. Only accept names it keeps as is (same rule as Corpo).
// Separators only sit between letter groups, so the match stays linear: a whitespace run, a hyphen or an apostrophe,
// optionally surrounded by whitespaces (Directory `squish`es them).
const directoryNameLetters = 'a-zA-ZÀ-ÖØ-öø-ÿ'
export const directoryNameRegExp = new RegExp(
  `^[${directoryNameLetters}]+(?:(?:\\s+(?:['-]\\s*)?|['-]\\s*)[${directoryNameLetters}]+)*$`,
)

export const isMatchingEmailOrMailInvitationUrl = (code?: string, token?: string): boolean =>
  Boolean(code?.match(/^\w{12}$/) && token?.match(/^\w{12}$/))

export const isMatchingCardInvitationUrl = (code?: string, token?: string): boolean =>
  // a regex to math only 4 digits string
  Boolean(code?.match(/^\d{4}$/) && token?.match(/^\d{9,10}$/))
